<!-- 底部组件——4 -->
<template>
  <div class="bottom-four">
    <main>
      <div class="lng">
        <div class="title">
          <div class="title-text">LNG储气罐</div>
        </div>
        <div class="lng-content">
          <article 
          v-for="(item,index) of lngData"
          :key="index">
            <div>
              <p>{{item.title}}</p>
              <p>{{item.num}}<span>千米³</span></p>
            </div>
          </article>
        </div>
      </div>

      <!-- 罐体信息 -->
      <div class="pot-info">
        <div class="title">
          <div class="title-text">罐体信息</div>
        </div>
        <table>
          <thead>
            <tr>
              <th>编号</th>
              <th>位置</th>
              <th>状态</th>
            </tr>
          </thead>
          <tbody>
            <div
            v-for="(item,index) in potInfo" :key="index">
            <tr :class="item.potState">
              <td><div class="tab-round"></div>{{item.number}}</td>
              <td>{{item.position}}</td>
              <td>{{item.state}}</td>
            </tr>
            </div>
          </tbody>
        </table>
      </div>

      <!-- 报警信息 -->
      <div class="alert-info">
        <div class="title">
          <div class="title-text">报警信息</div>
        </div>
        <table>
          <thead>
            <tr>
              <th>报警编号</th>
              <th>设备位置</th>
              <th>报警内容</th>
              <th>报警时间</th>
            </tr>
          </thead>
          <tbody>
            <tr
            v-for="(item,index) in alertInfo" :key="index"
            :class="item.stateStyle">
              <td><div class="tab-round"></div>{{item.number}}</td>
              <td>{{item.position}}</td>
              <td>{{item.content}}</td>
              <td>{{item.time}}</td>
            </tr>
          </tbody>
          <div class="line"></div>
        </table>
      </div>
    </main>
  </div>
</template>
<script>
export default {
  name:'BottomFour',
  data(){
    return{
      // 储气罐数据
      lngData:[
        {
          title:'LNG储气罐今日储气',
          num: 38.3,
        },
        {
          title:'今日输油',
          num: 38.83
        },
        {
          title:'月平均日输',
          num: 34.87,
        },
        {
          title:'年度累计',
          num: 6.89
        },
        {
          title:'周平均日输',
          num: 39.22,
        },
        {
          title:'本月度累计',
          num: 913.22,
        }
      ],
      // 罐体信息数据
      potInfo:[
        {
          number: 201236,
          position: 'A区2-20',
          state: '正常',
          // 罐体状态样式
          potState:'',
        },
        {
          number: 201237,
          position: 'A区2-21',
          state: '停用',
          potState:'',
        },
        {
          number: 201238,
          position: 'A区2-22',
          state: '正常',
          potState:'',
        },
        {
          number: 201239,
          position: 'A区2-23',
          state: '正常',
          potState:'',
        },
      ],
      // 报警信息数据
      alertInfo:[
        {
          number:'AK001',
          position:'A区2-20',
          content:'漏气',
          time:'2022.4.18'
        },
        {
          number:'AK001',
          position:'A区2-20',
          content:'故障',
          time:'2022.4.18'
        },
        {
          number:'AK001',
          position:'A区2-20',
          content:'停用',
          time:'2022.4.18'
        },
        {
          number:'AK001',
          position:'A区2-20',
          content:'离线',
          time:'2022.4.18'
        },
      ],
    }
  },
  created(){
    this.getPotInfo();
    this.getAlert()
  },
  methods:{
    // 获取罐体信息数据
    getPotInfo(){
      // 判断状态修改颜色
      this.potInfo.map((item,index) =>{
        if(item.state === '停用'){
          this.potInfo[index].potState = 'stop'
        }
      })
    },

    // 获取报警信息
    getAlert(){
      // 判断状态设置样式
      this.alertInfo.map((item,index) =>{
        switch(item.content){
          case '漏气':
            this.alertInfo[index].stateStyle = 'leak'
            break
          case '故障':
            this.alertInfo[index].stateStyle = 'fault'
            break
          case '停用':
            this.alertInfo[index].stateStyle = 'stop'
            break
          case '离线':
            this.alertInfo[index].stateStyle = 'offline'
            break
        }
      })
    }
  }
}
</script>
<style lang="less" scoped>
.bottom-four{
  position: absolute;
  bottom:0px;
  width: 100%;
  height:27.5vh;
  main{
    width: 93.073vw;
    height: 100%;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    font-family: sy;
    .title{
      margin-bottom: 2.222vh;
      width: 12.708vw;
      font-family: ysbth;
    }
  // 储气罐样式开始
    .lng{
      width: 22.031vw;
      .lng-content{
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        align-items: center;
        article{
          color: #fff;
          width:30%;
          margin-bottom: 10px;
          height: 7.814vh;
          background-color: rgba(0,0,0,0.3);
          position:relative;
          display: flex;
          align-items: center;
          background-image: url(../assets/four/lng_tri.png);
          background-repeat: no-repeat;
          p{
            margin: 0;
            padding: 0;
            margin-left: 10px;
          }
          p:first-child{
            font-size: 10px;
            line-height: 22px;
          }
          p:last-child{
            font-size: 20px;
            font-weight: bold;
            span{
              margin-left: 5px;
              font-size: 10px;
              color: rgba(255, 255, 255, 0.3);
            }
          }
        }
      }
    }
    // 储气罐样式结束

    // 罐体信息样式开始
    .pot-info{
      width:31.041vw;
      height:100%;
      table tr{
        padding-right: 6%;
      }
      table tbody tr{
        margin:4px 0;
      }
      table tbody >div:nth-child(even){
        border-bottom: 1px dashed rgba(152, 254, 249, 0.5);
      }
      // 设置斑马线样式,odd奇数行，even偶数行
      table tbody > div:nth-child(even) tr{
        background-color: rgba(152, 254, 249, 0.3);
      }
      // 设置状态文字颜色
      table tbody tr td:last-child{
        color:#30c74d;
      }
      // 停用时的样式
      .stop{
        color:#ff9600;
        .tab-round{
          background-color:#ff9600;
        }
      }
    }
    // 罐体信息样式结束

    // 报警信息样式开始
    .alert-info{
      width: 31.0941vw;
      height:100%;

      // 表格样式
      table{
        thead{
          tr{
            width: 92%;
          }
        }
        tbody{
          float: left;
          width: 92%;
          tr{
            border-bottom: 1px dashed rgba(152, 254, 249, 0.5);
          }
          // 状态为漏气时样式
          .leak{
            .tab-round{
              background-color: #fcff20;
            }
            td:nth-child(3){
              color: #fcff20;
            }
          }
          // 状态为故障样式
          .fault{
            .tab-round{
              background-color: #ff9600;
            }
            td:nth-child(3){
              color:#ff9600;
            }
          }
          // 停用样式
          .stop{
            .tab-round{
              background-color: #ff9600;
            }
            td:nth-child(3){
              color: #ff9600;
            }
          }
          // 离线样式
          .offline{
            .tab-round{
              background-color: #30c74d;
            }
            td:nth-child(3){
              color: #30c74d;
            }
          }
        }
        // 最右边的一个小竖线
        .line{
          width: 0.208vw;
          height: 2.407vh;
          background-color: rgba(152,254,249,0.5);
          border-radius: 20%;
          float: right;
          margin-top: 1.296vh;
        }
      }
    }
    // 报警信息样式结束

    // 表格样式开始
    table{
      color:#fff;
      width:100%;
      font-size: 12px;
      font-weight: 400;
      text-align: center;
      line-height: 200%;
      thead{
        display: block;
        height:2.593vh;
        background: url(../assets/four/table_head.png) no-repeat;
        background-size: 100% 100%;
        background-color: rgba(152, 254, 249, 0.3);
        th{
          font-size: 12px;
          font-weight: 400;
        }
      }
      tr{
        height:2.593vh;
        display: flex;
        justify-content: space-between;

        margin: 5px 0;
        .tab-round{
          width: 0.375vw;
          height: 0.375vw;
          border-radius: 50%;
          display: inline-block;
          background-color:#fff;
          margin-right:8px;
        }
      }
      th:first-child{
        margin-left: 24px;
      }
      td:first-child{
        margin-left: 10px;
      }
      tbody tr:hover{
        cursor: pointer;
      }
    }
    // 表格样式结束
  }
}
</style>